export type SortCompare<T> = (first: T, second: T) => number;

export function sortEditableFirst<T>(
  items: readonly T[],
  canEdit: (item: T) => boolean,
  thenBy?: SortCompare<T>,
): T[] {
  return [...items].sort((first, second) => {
    const byEdit = Number(canEdit(second)) - Number(canEdit(first));
    if (byEdit !== 0) {
      return byEdit;
    }
    return thenBy ? thenBy(first, second) : 0;
  });
}

/** Newest start, then highest id — keeps a just-created item on page 1 when dates collide. */
export function compareByStartTimeThenIdDesc(
  first: { id?: number; startTime?: string },
  second: { id?: number; startTime?: string },
): number {
  const secondTime = Date.parse(second.startTime ?? '') || 0;
  const firstTime = Date.parse(first.startTime ?? '') || 0;
  if (secondTime !== firstTime) {
    return secondTime - firstTime;
  }
  return (second.id ?? 0) - (first.id ?? 0);
}
